var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189.5,
    height: 27.627,
    viewBox: "0 0 189.5 27.627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3168",
    "data-name": "Rectangle 3168",
    width: 189.5,
    height: 27.627,
    fill: "#06233d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14955",
    "data-name": "Group 14955",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4525",
    "data-name": "Group 4525",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12561",
    "data-name": "Path 12561",
    d: "M28.192,22.14a2.882,2.882,0,0,0-.745.136L18.094,2.555A2.973,2.973,0,0,0,15.451.725a2.9,2.9,0,0,0-2.643,1.83L3.388,22.275a2.436,2.436,0,0,0-.745-.136,2.609,2.609,0,1,0,1.626.542L13.622,2.961a2.1,2.1,0,0,1,1.83-1.288,2.1,2.1,0,0,1,1.83,1.288l9.352,19.721a2.649,2.649,0,1,0,4.269,2.1,2.75,2.75,0,0,0-2.711-2.643m-25.549,4.2a1.626,1.626,0,0,1,0-3.253,1.649,1.649,0,0,1,1.626,1.626,1.605,1.605,0,0,1-1.626,1.626m25.549,0a1.626,1.626,0,1,1,1.626-1.626,1.605,1.605,0,0,1-1.626,1.626",
    transform: "translate(0 -0.234)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12562",
    "data-name": "Path 12562",
    d: "M55.717,22.208V5.943a2.643,2.643,0,1,0-.949,0V22.208a2.632,2.632,0,1,0,3.117,2.575,2.687,2.687,0,0,0-2.169-2.575m-2.1-18.84a1.626,1.626,0,1,1,3.253,0,1.649,1.649,0,0,1-1.626,1.626,1.7,1.7,0,0,1-1.626-1.626m1.626,22.974a1.626,1.626,0,1,1,1.626-1.626,1.605,1.605,0,0,1-1.626,1.626",
    transform: "translate(-16.954 -0.234)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12563",
    "data-name": "Path 12563",
    d: "M87.373,20.2a2.843,2.843,0,0,0-1.108-2.41,14.516,14.516,0,0,0-3.989-1.773,28.282,28.282,0,0,1-4.562-1.838q-4.58-2.474-4.58-6.666a6.491,6.491,0,0,1,1.229-3.888A8.017,8.017,0,0,1,77.89.961,13.287,13.287,0,0,1,83.052,0a12.078,12.078,0,0,1,5.133,1.044,8.169,8.169,0,0,1,3.5,2.945,7.631,7.631,0,0,1,1.239,3.946.367.367,0,0,1-.366.375h-4.82a.364.364,0,0,1-.359-.349,3.505,3.505,0,0,0-1.152-2.523,4.784,4.784,0,0,0-3.269-1.025,5.111,5.111,0,0,0-3.158.859,2.711,2.711,0,0,0-1.126,2.262A2.594,2.594,0,0,0,80,9.733a14.916,14.916,0,0,0,3.888,1.662,16.8,16.8,0,0,1,6.889,3.527,7.026,7.026,0,0,1,2.16,5.245,6.472,6.472,0,0,1-2.641,5.476,11.557,11.557,0,0,1-7.11,1.986,13.73,13.73,0,0,1-5.651-1.136,8.946,8.946,0,0,1-3.888-3.112,7.873,7.873,0,0,1-1.332-4.2.367.367,0,0,1,.367-.375h4.837a.363.363,0,0,1,.356.351q.205,4.1,5.31,4.1a5.175,5.175,0,0,0,3.084-.8A2.613,2.613,0,0,0,87.373,20.2",
    transform: "translate(-20.328 0)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12564",
    "data-name": "Path 12564",
    d: "M128.856,5.033h-7.7V26.894a.539.539,0,0,1-.539.539h-4.461a.54.54,0,0,1-.54-.539V5.033h-7.585a.54.54,0,0,1-.54-.539V1.085a.54.54,0,0,1,.54-.54h20.823a.54.54,0,0,1,.539.54V4.493a.54.54,0,0,1-.539.539",
    transform: "translate(-31.668 -0.176)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12565",
    "data-name": "Path 12565",
    d: "M165.776.545a.6.6,0,0,1,.6.6v17.11a9.069,9.069,0,0,1-2.761,6.981,10.646,10.646,0,0,1-7.544,2.567,10.763,10.763,0,0,1-7.48-2.493,8.911,8.911,0,0,1-2.825-6.851V1.145a.6.6,0,0,1,.6-.6h4.341a.6.6,0,0,1,.6.6V18.292a5.123,5.123,0,0,0,1.265,3.851,4.856,4.856,0,0,0,3.5,1.209q4.672,0,4.746-4.912V1.145a.6.6,0,0,1,.6-.6Z",
    transform: "translate(-44.004 -0.176)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12566",
    "data-name": "Path 12566",
    d: "M184.555,26.808V1.171a.626.626,0,0,1,.626-.626h7.648a12.568,12.568,0,0,1,6.344,1.6,11.15,11.15,0,0,1,4.368,4.543,14.015,14.015,0,0,1,1.57,6.694v1.237a14.048,14.048,0,0,1-1.542,6.666,11.037,11.037,0,0,1-4.349,4.525,12.656,12.656,0,0,1-6.334,1.625h-7.7a.626.626,0,0,1-.626-.626M190.1,5.033V22.983h2.678a6.018,6.018,0,0,0,4.968-2.124,9.594,9.594,0,0,0,1.754-6.075V13.361q0-4.1-1.7-6.214a6,6,0,0,0-4.967-2.114Z",
    transform: "translate(-56.506 -0.176)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12567",
    "data-name": "Path 12567",
    d: "M227.955,27.434h-4.332a.6.6,0,0,1-.6-.6V1.149a.6.6,0,0,1,.6-.6h4.332a.6.6,0,0,1,.6.6v25.68a.6.6,0,0,1-.6.6",
    transform: "translate(-68.903 -0.176)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12568",
    "data-name": "Path 12568",
    d: "M262.144,14.423a16.237,16.237,0,0,1-1.4,6.962A10.576,10.576,0,0,1,256.724,26a11.869,11.869,0,0,1-11.958.018,10.675,10.675,0,0,1-4.063-4.589,15.762,15.762,0,0,1-1.459-6.86v-1.33a16.157,16.157,0,0,1,1.431-6.99,10.663,10.663,0,0,1,4.045-4.635,11.853,11.853,0,0,1,11.948,0,10.662,10.662,0,0,1,4.044,4.635,16.111,16.111,0,0,1,1.431,6.971ZM256.53,13.2a11.314,11.314,0,0,0-1.515-6.427,5.349,5.349,0,0,0-8.624-.028,11.184,11.184,0,0,0-1.533,6.362v1.311a11.451,11.451,0,0,0,1.515,6.39,5.3,5.3,0,0,0,8.643.083,11.4,11.4,0,0,0,1.515-6.38Z",
    transform: "translate(-74.133 0)",
    fill: "#06233d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d0ce1baa7b71ef23f1898d562d05e5d6.svg";
export { ForwardRef as ReactComponent };